import { Link } from "react-router-dom";
import PortalLayout from "../../components/PortalLayout";
import { useI18n } from "../../i18n/LanguageContext";

const CARDS = [
  { key: "philosophy", to: "/explore/philosophy", testid: "explore-card-philosophy" },
  { key: "compliance", to: "/explore/compliance", testid: "explore-card-compliance" },
  { key: "faq", to: "/explore/faq", testid: "explore-card-faq" },
];

export default function ExploreHubPage() {
  const { t } = useI18n();
  return (
    <PortalLayout>
      <section
        className="max-w-[1280px] mx-auto px-6 sm:px-8 pt-14 pb-8"
        data-testid="explore-hub-page"
      >
        <div className="br-fade-up">
          <div className="br-overline" data-testid="explore-overline">
            {t("explore.overline")}
          </div>
          <h1
            className="font-serif-display text-[clamp(2.4rem,4.5vw,3.8rem)] mt-3"
            data-testid="explore-title"
          >
            {t("explore.title")}
          </h1>
          <p className="text-[1.05rem] text-[color:var(--br-text)] mt-3 max-w-[680px]">
            {t("explore.intro")}
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5 br-fade-up br-delay-1">
          {CARDS.map((c) => (
            <Link
              key={c.key}
              to={c.to}
              className="br-card p-7 group transition-transform duration-300 hover:-translate-y-1"
              data-testid={c.testid}
            >
              <div className="br-overline">{t(`explore.${c.key}`)}</div>
              <h2 className="font-serif-display text-[1.7rem] mt-3 text-[color:var(--br-parchment)] leading-tight">
                {t(`explore.${c.key}`)}
              </h2>
              <p className="text-[0.92rem] text-[color:var(--br-text-dim)] mt-4 leading-relaxed">
                {t(`explore.card_${c.key}_desc`)}
              </p>
              <div
                className="mt-7 font-mono-fin text-[0.66rem] tracking-[0.24em] uppercase"
                style={{ color: "var(--br-bronze)" }}
              >
                {t("explore.read")}
              </div>
            </Link>
          ))}
        </div>
      </section>
    </PortalLayout>
  );
}
